import { InjectionToken } from '@angular/core';

export const VERSION: InjectionToken<string> = new InjectionToken('version');
